<template>
  <router-view />
</template>

<script>
export default {
  name: "CalendarPage",
  data() {
    return {};
  }
};
</script>

<style scoped>
</style>